<template>
  <v-data-table
    :headers="headers"
    :items="countries"
    :sort-by="[{ key: '#', order: 'asc' }]"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title
          class="text-h6 text-uppercase font-weight-bold text--darken-1 justify-center text-black"
          >Countries</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ props }">
            <v-text-field
              v-model="search"
              density="compact"
              variant="flat"
              label="Search"
              append-inner-icon="mdi-magnify"
              class="ma-3"
              single-line
              hide-details
            ></v-text-field>
            <v-btn
              class="mb-2"
              dark
              size="large"
              prepend-icon="mdi-plus-thick"
              variant="elevated"
              v-bind="props"
              color="black"
            >
              New Country
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span
                class="text-caption text-uppercase font-weight-bold text--darken-1 justify-center text-black"
                >{{ formTitle }}</span
              >
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="isValid" @submit.prevent="save">
                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <v-text-field
                        v-model="editedItem.title"
                        label="Name"
                        color="black"
                        :rules="rules.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <v-text-field
                        v-model="editedItem.currency"
                        label="Currency"
                        color="black"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field
                        v-model="editedItem.lat"
                        label="Latitude"
                        color="black"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field
                        v-model="editedItem.lag"
                        label="Longitude"
                        color="black"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <v-text-field
                        v-model="editedItem.countryCode"
                        label="Country Code"
                        color="black"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <v-textarea
                        v-model="editedItem.description"
                        label="Descriptions"
                        color="black"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions class="mr-7 mt-n7 mb-4">
              <v-spacer></v-spacer>
              <v-btn color="error" variant="flat" @click="close">
                Cancel
              </v-btn>
              <v-btn
                color="black"
                variant="flat"
                :disabled="!isValid"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card class="mx-10">
            <v-card-title class="text-subtitle-2 text-center text-black">
              You sure you want to delete this country?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" variant="flat" @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="black" variant="flat" @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.id`]="{ index }">
      {{ index + 1 }}
    </template>
    <template v-slot:[`item.description`]="{ item }">
      {{ item.description ? item.description : "N/A" }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        class="me-2"
        color="black"
        size="x-small"
        variant="flat"
        icon="mdi-pencil"
        @click="editItem(item)"
      ></v-btn>
      <v-btn
        class="me-2"
        color="error"
        size="x-small"
        icon="mdi-delete"
        variant="flat"
        @click="deleteItem(item)"
      ></v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn color="black" variant="flat" @click="initialize"> Reset </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import CountriesService from "../services/country.services.js";
export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    isValid: false,
    rules: {
      name: [
        (value) => {
          if (value?.length >= 3) return true;
          return "You must enter a name.";
        },
      ],
    },
    headers: [
      {
        title: "#",
        value: "id",
        align: "start",
        sortable: false,
        key: "id",
      },
      { title: "Name", value: "title", key: "title" },
      { title: "Carrency", value: "currency", key: "currency" },
      { title: "Latitude", value: "lat", key: "lat" },
      { title: "Longitude", value: "lag", key: "lag" },
      { title: "Country Code", value: "countryCode", key: "countryCode" },
      { title: "Description", value: "description", key: "description" },
      { title: "Actions", key: "actions", sortable: false },
    ],

    editedIndex: -1,
    countries: [],
    editedItem: {
      name: "",
      title:"",
      currency: "",
      description: "",
      lat: "",
      lag: "",
      countryCode: "",
    },
    defaultItem: {
      name: "",
      title:"",
      currency: "",
      description: "",
      lat: "",
      lag: "",
      countryCode: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Country" : "Edit Country";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.getCountries();
  },

  methods: {
    async validate() {
      this.isValid = await this.$refs.form.validate();
    },

    handleLogout() {
      this.$store.commit("logout");
      this.$store.dispatch("resetInactivityTimeout");
      this.$store.dispatch("auth/logout");
      this.$store.dispatch("resetInactivityTimeout");
      this.$router.push("/login");
      this.$store.dispatch("alert/success", "Logout Successfully");
    },
    
    getCountries() {
      return CountriesService.index().then(
        (response) => {
          if (response.status == 200) {
            this.countries = response.data.data;
            this.loading = false;
          } else {
            this.countries = [];
            this.loading = false;
            console.log(response.data.console.error);
          }
        },
        (error) => {
          this.countries = [];
          if (error.response.status == 401) {
            this.handleLogout();
          }
          console.log(error);
          this.$store.dispatch("alert/error", error.message);
        }
      );
    },

    editItem(item) {
      this.editedIndex = this.countries.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.countries.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      CountriesService.delete(this.editedItem).then(
        (response) => {
          if (response.status == 200) {
            this.$store.dispatch("alert/success", response.data.message);
            this.countries.splice(this.editedIndex, 1);
            this.closeDelete();
          } else {
            this.$store.dispatch("alert/error", response.data.message);
          }
        },
        (error) => {
          if (error.response.status == 422) {
            this.$store.dispatch("alert/error", error.response.data.message);
          }
          console.log(error);
          this.$store.dispatch("alert/error", error.response.data.message);
        }
      );
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      this.editedItem.name = this.editedItem.title;
      if (this.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.countries[this.editedIndex], this.editedItem);
          CountriesService.update(this.editedItem).then(
            (response) => {
              if (response.status == 200) {
                this.$store.dispatch("alert/success", response.data.message);
                this.close();
                this.loading = false;
              } else {
                this.$store.dispatch("alert/error", response.data.message);
                this.loading = false;
              }
            },
            (error) => {
              if (error.response.status == 422) {
                this.$store.dispatch(
                  "alert/error",
                  error.response.data.message
                );
                this.loading = false;
              }
              console.log(error);
              this.$store.dispatch("alert/error", error.response.data.message);
            }
          );
        } else {
          CountriesService.store(this.editedItem).then(
            (response) => {
              if (response.status == 201) {
                this.countries.push(this.editedItem);
                this.$store.dispatch("alert/success", response.data.message);
                this.loading = false;
                this.close();
              } else {
                this.$store.dispatch("alert/error", response.data.message);
                this.loading = false;
              }
            },
            (error) => {
              if (error.response.status == 422) {
                this.$store.dispatch(
                  "alert/error",
                  error.response.data.message
                );
                this.loading = false;
              }
              console.log(error);
              this.$store.dispatch("alert/error", error.response.data.message);
            }
          );
        }
      }
    },
  },
};
</script>